// @ts-nocheck
import { Link } from 'react-router-dom';
import { Container, Stack, Grid, Group } from '@/components/ui/layout';
import { Card } from '@/components/ui/data-display';
import { Title, Text, Badge, Button } from '@/components/ui/core';
import { IconEye, IconArrowLeft } from '@tabler/icons-react';

const variants = [
  {
    name: 'Simple',
    path: 'simple',
    description: 'Clean reset password form with strength indicator',
    features: ['Password strength', 'Confirm password', 'Simple layout'],
  },
  {
    name: 'Split',
    path: 'split',
    description: 'Two-column layout with security tips',
    features: ['Security tips', 'Requirements list', 'Responsive'],
  },
  {
    name: 'Gradient',
    path: 'gradient',
    description: 'Gradient background with animated lock icon',
    features: ['Glass effect', 'Visual strength', 'Modern look'],
  },
  {
    name: 'Modern',
    path: 'modern',
    description: 'Contemporary design with requirements checklist',
    features: ['Requirements list', 'Real-time validation', 'Animated'],
  },
  {
    name: 'Cover',
    path: 'cover',
    description: 'Full background image with compact reset form',
    features: ['Cover image', 'Compact form', 'Strength bar'],
  },
  {
    name: 'Animated',
    path: 'animated',
    description: 'Motion-focused design with staggered animations',
    features: ['Staggered animations', 'Floating orbs', 'Hover effects'],
  },
  {
    name: 'Illustrated',
    path: 'illustrated',
    description: 'Custom SVG illustrations with stock photography',
    features: ['SVG illustrations', 'Stock images', 'Split layout'],
  },
  {
    name: 'Parallax',
    path: 'parallax',
    description: 'Mouse-responsive parallax background effects',
    features: ['Parallax layers', 'Mouse tracking', 'Glass card'],
  },
  {
    name: 'Neon',
    path: 'neon',
    description: 'Cyberpunk-inspired design with glowing borders',
    features: ['Neon glow', 'Grid background', 'Cyberpunk theme'],
  },
  {
    name: 'Minimal 3D',
    path: 'minimal3d',
    description: 'Clean design with interactive 3D tilt effect',
    features: ['3D tilt effect', 'Floating shadow', 'Minimal style'],
  },
  {
    name: 'Split Screen',
    path: 'splitscreen',
    description: '50/50 layout with testimonial panel and reset form',
    features: ['Testimonial panel', 'Password strength', 'Trust badge'],
  },
];

export default function ResetPasswordOverview() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        {/* Header */}
        <Group justify="space-between" align="flex-start">
          <div>
            <Button
              component={Link}
              to="/demo/auth-pages"
              variant="subtle"
              leftSection={<IconArrowLeft size={16} />}
              mb="sm"
            >
              Back to Overview
            </Button>
            <Title order={1}>Reset Password Pages</Title>
            <Text c="dimmed" size="lg" mt="xs">
              17 unique reset password page designs with strength indicators and validation.
            </Text>
          </div>
          <Badge size="lg" color="green">
            17 Variants
          </Badge>
        </Group>

        {/* Variants Grid */}
        <Grid gutter="lg">
          {variants.map((variant) => (
            <Grid.Col key={variant.name} span={{ base: 12, sm: 6, lg: 4 }}>
              <Card variant="elevated" p="lg" h="100%">
                <Stack gap="md" h="100%">
                  <div>
                    <Title order={3} mb="xs">{variant.name}</Title>
                    <Text size="sm" c="dimmed" lineClamp={2}>
                      {variant.description}
                    </Text>
                  </div>

                  <Group gap="xs" wrap="wrap" style={{ flex: 1 }}>
                    {variant.features.map((feature) => (
                      <Badge key={feature} size="sm" variant="light" color="green">
                        {feature}
                      </Badge>
                    ))}
                  </Group>

                  <Button
                    component={Link}
                    to={variant.path}
                    variant="light"
                    color="green"
                    fullWidth
                    rightSection={<IconEye size={16} />}
                  >
                    Preview
                  </Button>
                </Stack>
              </Card>
            </Grid.Col>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
}
